import { useVariant } from "../hooks/useVariant"

type UIOptions = {
  fallback: React.ReactNode
  [variant: string]: React.ReactNode
}

type FeatureFlagUIProps = {
  flag: string
  fallback?: string
  variantUI: UIOptions
}

export const FeatureFlagUI = ({ flag, fallback = "off", variantUI }: FeatureFlagUIProps) => {
  const variant = useVariant(flag, {
    fallback,
    // This component is specifically for changing the UI, so we always want to track exposure
    disableExposureEvent: false,
  })
  const ui = variant.value in variantUI ? variantUI[variant.value] : variantUI.fallback

  return <>{ui}</>
}
